/**
 * EVENT_NAME_CONSTANT = {
 *     category: String (required),
 *     action: (required),
 *     label: (optional),
 *     value: (optional)
 * }
 */

// Price my rental
export const PMR_CATEGORY = 'ZRM_price_my_rental';
const pmrEvents = {
    WITH_COMPS_WITH_ZESTIMATE: {
        category: PMR_CATEGORY,
        label: 'comps_and_zestimate',
        action: 'success',
        description: 'Successfully returns comps and Zestimate.'
    },
    WITH_COMPS_WITH_OUT_ZESTIMATE: {
        category: PMR_CATEGORY,
        label: 'comps_no_zestimate',
        action: 'success',
        description: 'Successfully returns comps without a Zestimate.'
    },
    CANNOT_FIND_ADDRESS: {
        category: PMR_CATEGORY,
        label: 'no_zpid',
        action: 'error',
        description: 'Cannot find address.'
    },
    CANNOT_FIND_ADDRESS_ZESTIMATE: {
        category: PMR_CATEGORY,
        label: 'no_zestimate',
        action: 'error',
        description: 'Cannot find address zestimate.'
    },
    CANNOT_FIND_COMPS: {
        category: PMR_CATEGORY,
        label: 'no_comps',
        action: 'error',
        description: 'Cannot find comparables.'
    },

    // Landing page CTAs
    CONTINUE_BUTTON_ABOVE_FOLD: {
        category: PMR_CATEGORY,
        label: 'PriceMyRentalContinueAboveFold',
        action: 'Address_Submit'
    },
    CONTINUE_BUTTON_BELOW_FOLD: {
        category: PMR_CATEGORY,
        label: 'PriceMyRentalContinueBelowFold',
        action: 'Address_Submit'
    },

    // Results page CTAs
    LIST_HOME_FOR_RENT: {
        category: PMR_CATEGORY,
        label: 'ListHomeForRentButtonResultsPage',
        action: 'PostListing'
    },
    CLAIM_HOME: {
        category: PMR_CATEGORY,
        label: 'ClaimHomeCTAResultsPage',
        action: 'ClickClaimHome'
    },

    ZRM_TRY_ANOTHER_ADDRESS: {
        category: PMR_CATEGORY,
        action: 'TryAnotherAddress',
        label: 'TextLink'
    },

    // ZRM ChangePriceModal
    ZRM_LAUNCH_PRICE_CHANGE_MODAL_ZESTIMATE_CARD_TOP_PENCIL: {
        category: PMR_CATEGORY,
        action: 'LaunchPriceAdjustModal::TopPencil',
        label: 'PriceAdjustModal'
    },
    ZRM_PRICE_CHANGE_MODAL_CLOSE: {
        category: PMR_CATEGORY,
        action: 'CloseModal',
        label: 'PriceAdjustModal'
    },

    // Results page comps
    PRICE_CHANGE_MODAL_SAVE: {
        category: PMR_CATEGORY,
        // action: 'SaveZestimate / SaveCustom',
        label: 'PriceAdjustModal'
    }
};

// Rental market pages
export const RMP_CATEGORY = 'RentalMarketPage';
const rmpEvents = {
    AREA_SEARCH: {
        category: RMP_CATEGORY,
        action: 'AreaSearch'
    },
    VIEW_TOP_MARKET: {
        category: RMP_CATEGORY,
        action: 'ViewTopMarket'
    },
    VIEW_NEARBY_AREA: {
        category: RMP_CATEGORY,
        action: 'ViewNearbyArea'
    },
    AREA_DOES_NOT_EXIST: {
        category: RMP_CATEGORY,
        action: 'AreaSearchError::AreaDoesNotExist'
    },
    AREA_HAS_NO_DATA: {
        category: RMP_CATEGORY,
        action: 'AreaSearchError::NoData'
    },
    SEARCH_OTHER_AREA: {
        category: RMP_CATEGORY,
        action: 'SearchOtherArea'
    },
    BED_COUNT_FILTER: {
        category: RMP_CATEGORY,
        action: 'BedCountFilter'
    },
    PROPERTY_TYPE_FILTER: {
        category: RMP_CATEGORY,
        action: 'PropertyTypeFilter'
    },
    COMPARE_TO_MARKET: {
        category: RMP_CATEGORY,
        action: 'CompareToMarket'
    },
    COMPARE_TO_MARKET_NO_DATA: {
        category: RMP_CATEGORY,
        action: 'CompareToMarketFailed::NoData'
    },
    EXPLORE_RENTALS: {
        category: RMP_CATEGORY,
        action: 'ExploreRentals'
    },
    CLICK_SEO_FOOTER: {
        category: RMP_CATEGORY,
        action: 'ClickSEOFooter'
    }
};

export const gaEvents = {
    ...pmrEvents,
    ...rmpEvents,

    // Results page resource links
    RESOURCE_LINKS: {
        category: 'ResourceLinks',
        action: 'Click'
        // label: 'WhatIsTheRentZestimate / DeterminingRentalPriceTutorial / etc',
    },

    // No zestimate flow
    OPEN_NO_ZEST_MODAL: {
        category: 'NoZestimate',
        action: 'OpenModal'
    },
    SUBMIT_NO_ZEST_MODAL: {
        category: 'NoZestimate',
        action: 'Submit'
    },

    //GTM Custom Event
    GTM_CUSTOM_RENT_ZESTIMATE: {
        name: 'RentZestimate'
    },

    // Web vitals event
    WEB_VITALS_PERF_METRICS: {
        category: 'webVitals'
        // action: web vital name,
        // label: web vital id,
        // value: web vital value,
        // nonInteraction: true
    },

    // ZRM Upsell CTAs
    ZRM_UPSELL_POST_LISTING: {
        label: 'UpsellComponent',
        action: 'PostListing::Convert'
    },
    ZRM_UPSELL_POST_LISTING_LEARN_MORE: {
        label: 'UpsellComponent',
        action: 'PostListing::LearnMore'
    },
    ZRM_UPSELL_SCREEN_TENANTS: {
        label: 'UpsellComponent',
        action: 'Applications::Convert'
    },
    ZRM_UPSELL_SCREEN_TENANTS_LEARN_MORE: {
        label: 'UpsellComponent',
        action: 'Applications::LearnMore'
    },
    ZRM_UPSELL_SIGN_LEASE: {
        label: 'UpsellComponent',
        action: 'Leases::Convert'
    },
    ZRM_UPSELL_SIGN_LEASE_LEARN_MORE: {
        label: 'UpsellComponent',
        action: 'Leases::LearnMore'
    },
    ZRM_UPSELL_COLLECT_RENT: {
        label: 'UpsellComponent',
        action: 'Payments::Convert'
    },
    ZRM_UPSELL_COLLECT_RENT_LEARN_MORE: {
        label: 'UpsellComponent',
        action: 'Payments::LearnMore'
    },
    ZRM_UPSELL_FREE_LISTING: {
        label: 'UpsellComponent',
        action: 'FirstListingFree::Convert'
    }
};
